import React, { Component } from "react";
import { Div, Image, Text, Icon, Modal } from "atomize";
import {
  Player,
  ControlBar,
  CurrentTimeDisplay,
  TimeDivider,
  VolumeMenuButton,
} from "video-react";

const videoParams = {
  fluid: false,
  playsInline: true,
};

class ModalVideo extends Component {
  videoPlayer = React.createRef();

  componentDidMount() {
    this.videoPlayer.current.subscribeToStateChange(
      this.handleChange.bind(this)
    );
  }

  handleChange = (state, prevState) => {
    // Video Swiper Height
    // const height = document.querySelector(".video-slider-wrapper").clientHeight;
    // console.log(height);

    const height = window.innerHeight;

    if (state.isFullscreen === true && prevState.isFullscreen === false) {
      document
        .querySelector(".image-video-modal")
        .classList.add("video-fullscreen");

      document.querySelector(
        ".image-video-modal .swiper-container"
      ).style.height = `${height}px`;

      document
        .querySelector(".image-video-modal .swiper-slide-active .video-react")
        .setAttribute("style", `height: ${height}px !important`);
    }
    if (state.isFullscreen === false && prevState.isFullscreen === true) {
      document
        .querySelector(".image-video-modal")
        .classList.remove("video-fullscreen");

      document.querySelector(
        ".image-video-modal .swiper-container"
      ).style.height = `auto`;

      document
        .querySelector(".image-video-modal .swiper-slide-active .video-react")
        .setAttribute("style", `height: 100% !important`);
    }
  };

  render() {
    const { poster, source } = this.props;

    return (
      <Div pos="relative" bg="black" p={{ b: "120%" }}>
        <Div
          pos="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          d="flex"
          align="center"
          zIndex="1"
        >
          <Player
            {...videoParams}
            ref={this.videoPlayer}
            poster={poster}
            className="video-modal"
          >
            <source src={source} />

            <ControlBar>
              <CurrentTimeDisplay order={4.1} />
              <TimeDivider order={4.2} />
              <VolumeMenuButton order={8} />
            </ControlBar>
          </Player>
        </Div>
      </Div>
    );
  }
}

export default ModalVideo;
